import React from 'react';
import {StyleSheet, Text, TouchableOpacity, View} from "react-native";
import {useDispatch, useSelector} from 'react-redux';
import {getConnectionLogs, getLogsVisible, setLogsVisibility} from "../reducers/configSlice";
import {ScrollView} from "react-native-gesture-handler";

import {actuatedNormalize} from "../services/helpers/stylingHelpers";

const LogsContainer = () => {
    const dispatch = useDispatch()
    const logsVisible = useSelector(getLogsVisible)
    const connectionLogs = useSelector(getConnectionLogs)

    return (
        logsVisible ?
            <View style={styles.wrapper}>
                <TouchableOpacity style={styles.closeButton} onPress={ () => {dispatch(setLogsVisibility(false))}}>
                    <Text style={styles.closeButtonText}>CLOSE</Text>
                </TouchableOpacity>

                <ScrollView bounces={false} style={styles.dataContainer}>
                    {connectionLogs.map( (log) => {
                        return <Text key={Math.random()} style={styles.dataText}>$: {log}</Text>
                    })}
                </ScrollView>
            </View>
            : null
    );
};

const styles = StyleSheet.create({
    wrapper: {
        position: 'absolute',
        top: 0,
        backgroundColor: 'rgba(0,0,0,0.9)',
        width: '100%',
        height: '100%',
        zIndex: 10000
    },
    closeButton: {
        zIndex: 10000,
        backgroundColor: 'red',
        opacity: 0.9, padding: 0,
        alignSelf: 'center',
        marginTop: '2.5%',
        marginBottom: '2.5%',
        paddingTop: '2%',
        paddingBottom: '2%',
        paddingRight: '5%',
        paddingLeft: '5%'
    },
    closeButtonText: {
        fontSize: actuatedNormalize(15),
        color: 'white',
    },
    dataContainer: {
        width: '100%',
        height: '100%'
    },
    dataText: {
        color: 'white',
        fontSize: actuatedNormalize(15),
    }
});

export default LogsContainer;
